const RESOURCE_NAME = '/shipments-notifs-emails';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});